
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30703',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30703",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55206",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8267",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11722",
  "I18n": "static-7.1661",
  "quartz": "static-1.7357",
  "quartz-config": "static-1.1135",
  "quartz-core": "static-1.6576",
  "react-dlb": "static-1.84",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.75",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.868",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55193",
  "feedback-utils": "static-1.55197",
  "forms-embed-utils-lib": "static-1.4705",
  "forms-utils-lib": "static-1.13008",
  "foundations-assets": "static-1.5115",
  "foundations-components": "static-1.8372",
  "foundations-theming": "static-1.4694",
  "hub-http": "static-1.6452",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12029",
  "icons": "static-2.674",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4087",
  "raven": "static-3.5925",
  "react": "static-7.190",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16948",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5510",
  "react-virtualized": "static-2.103",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.495",
  "tinymce-plugins": "static-1.58101",
  "transmute": "static-2.85",
  "ui-images": "static-2.1228",
  "UIComponents": "static-3.8668",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3571",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3634",
  "quartz-webpack": "static-1.3581",
  "foundations-theming-specialty": "static-1.2410",
  "property-description-translator": "static-1.4078",
  "HeadJS": "static-2.789",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3378",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4558",
  "jasmine-runner": "static-1.6689",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.867",
  "hubspotter-http": "static-1.4819",
  "mobile-manifest-mixins": "static-1.564",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1032",
  "quartz-head": "static-1.1022",
  "quartz-i18n": "static-1.1032",
  "quartz-routing": "static-1.787",
  "quartz-test": "static-1.1032",
  "quartz-tracking": "static-1.736",
  "trellis-components": "static-1.2465",
  "ui-fonts": "static-1.984",
  "usage-tracker-container": "static-1.7586",
  "usage-tracker-core": "static-1.7446",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7489",
  "reference-resolvers": "static-1.8423",
  "sanitize-text": "static-1.8390",
  "PatternValidationJS": "static-1.3136",
  "ReduxMessenger": "static-2.10606",
  "sanitize": "static-1.4716",
  "outpost": "static-1.4402",
  "rpc-client-utils": "static-1.4903",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4641",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9666",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.60",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2446",
  "bend-plugin-foundations-theming": "static-1.3177",
  "foundations-theming-base": "static-1.3679",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.250",
  "csstype": "static-1.50",
  "web-vitals": "static-1.10",
  "ai-components-ui-library": "static-1.9567",
  "atom": "static-1.5317",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8121",
  "ContentUtils": "static-1.69040",
  "data-token-picker": "static-1.16805",
  "file-manager-components": "static-1.24342",
  "FileManagerCore": "static-1.39841",
  "FileManagerLib": "static-1.39982",
  "frontend-preferences-client": "static-1.8168",
  "hub-http-contrib": "static-1.3279",
  "interframe": "static-3.4996",
  "layout-dnd-components": "static-1.12879",
  "layout-dnd-utils": "static-1.11854",
  "property-translator": "static-1.5634",
  "react-codemirror": "static-1.10880",
  "react-colorpicker": "static-2.10447",
  "reference-resolvers-lite": "static-1.8339",
  "rich-text-lib": "static-1.20225",
  "tinymce-data": "static-1.41072",
  "tinymce-themes": "static-1.56957",
  "ui-addon-emoji-picker": "static-1.10126",
  "ui-addon-sales-email": "static-1.5453",
  "ui-brand-identity-lib": "static-1.16197",
  "bender-build-tools": "static-1.3358",
  "hub-http-shared-msw-handlers": "static-1.10514",
  "hubspotter-http-shared-msw-handlers": "static-1.10512",
  "usage-tracker-session-replay": "static-1.5282",
  "base-ui": "static-1.18",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1200",
  "tanstack-virtual": "static-1.35",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.313",
  "chirp-fetch": "static-1.2129",
  "chatspot-core": "static-1.22606",
  "copilot-toolkit": "static-1.11729",
  "customer-data-objects-ui-components": "static-1.13271",
  "data-fetching-client": "static-1.9897",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4997",
  "ui-addon-video-player": "static-1.8945",
  "ui-coaching-tips": "static-1.29199",
  "usage-tracker": "static-1.7596",
  "cms-field-types": "static-1.5055",
  "content-icons-ui": "static-1.2304",
  "integrations-lib": "static-1.16910",
  "customer-data-objects": "static-1.7927",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1555",
  "apollo-link-hub-http": "static-2.4897",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.94",
  "immerable": "static-1.4392",
  "ui-addon-iframeable": "static-1.9317",
  "video-components-external": "static-1.12038",
  "video-data-lib": "static-1.35696",
  "breeze-artifacts-sdk": "static-1.159",
  "audio-components": "static-1.6263",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29724",
  "FileManagerImages": "static-1.37493",
  "foundations-components-legacy": "static-1.1397",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.73",
  "salesImages": "static-1.530",
  "ui-universal-auth": "static-1.9273",
  "urlinator": "static-1.4773",
  "video-components": "static-1.14040",
  "video-embed": "static-1.36530",
  "ts-schema": "static-1.4249",
  "ContentData": "static-1.69115",
  "layout-data-lib": "static-1.10179",
  "react-dnd-compat": "static-1.4856",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1785",
  "external-options-client-types": "static-1.4296",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7133",
  "hs-promise-utils": "static-1.5835",
  "inbound-db-properties-service-client": "static-1.4013",
  "NamespacedHubStyle": "static-2.9218",
  "growth-onboarding-confetti": "static-1.3301",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11385",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5715",
  "magpie-types": "static-1.5175",
  "simple-logging-lib": "static-1.3289",
  "avatar-components": "static-1.2737",
  "customer-data-ui-utilities": "static-1.10066",
  "growth-onboarding-feedback-components": "static-1.6823",
  "flux-actions": "static-1.360",
  "hubspot-apollo-client": "static-1.5118",
  "integrations-error-boundary-lib": "static-1.14325",
  "integrations-tracking-lib": "static-1.5848",
  "laboratory-lib": "static-3.7392",
  "native-integrations-shared-strings": "static-1.8017",
  "redux-observable": "static-1.71",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10502",
  "unified-auth": "static-1.787",
  "breeze-engine-chat-components": "static-1.533",
  "breeze-engine-core": "static-1.833",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.8029",
  "content-media-composition-data-lib": "static-1.13083",
  "content-media-compositions": "static-2.17090",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19326",
  "unified-auth-core-lib": "static-1.1069",
  "social-insights-client-types": "static-1.22685",
  "advanced-menus-core": "static-1.15502",
  "advanced-menus-lib": "static-1.12385",
  "ExportDialog": "static-6.10620",
  "ui-memberships-settings-lib": "static-1.34693",
  "conditional-properties-service-client": "static-1.3969",
  "crm-pipelines-api-client-types": "static-1.4305",
  "fdsr-migration-layer": "static-1.252",
  "framework-builder-read-service-client": "static-1.4176",
  "framework-data-schema-quick-fetch": "static-1.7038",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3863",
  "persist-promise": "static-1.3942",
  "foundations-components-test-utils": "static-1.5855",
  "reactive-lib": "static-1.961",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.577",
  "universal-page-editor-lib": "static-1.3250",
  "adobe-sign-auth-lib": "static-1.336",
  "ads-unified-auth-lib": "static-1.948",
  "google-sheets-integration-lib": "static-1.914",
  "microsoft-drive-integration-lib": "static-1.1068",
  "surveymonkey-integration-lib": "static-1.358",
  "slack-ui-library": "static-1.10637",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3978",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15501",
  "simple-menus-lib": "static-1.17018",
  "crm-record-cards-service-types": "static-1.3751",
  "location-customization-utils-lib": "static-1.9974",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30703",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55206",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8267",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11722",
  "I18n": "/I18n/static-7.1661",
  "quartz": "/quartz/static-1.7357",
  "quartz-config": "/quartz-config/static-1.1135",
  "quartz-core": "/quartz-core/static-1.6576",
  "react-dlb": "/react-dlb/static-1.84",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.75",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.868",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55193",
  "feedback-utils": "/feedback-utils/static-1.55197",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4705",
  "forms-utils-lib": "/forms-utils-lib/static-1.13008",
  "foundations-assets": "/foundations-assets/static-1.5115",
  "foundations-components": "/foundations-components/static-1.8372",
  "foundations-theming": "/foundations-theming/static-1.4694",
  "hub-http": "/hub-http/static-1.6452",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12029",
  "icons": "/icons/static-2.674",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4087",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.190",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16948",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5510",
  "react-virtualized": "/react-virtualized/static-2.103",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "tinymce-plugins": "/tinymce-plugins/static-1.58101",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1228",
  "UIComponents": "/UIComponents/static-3.8668",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3571",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3634",
  "quartz-webpack": "/quartz-webpack/static-1.3581",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2410",
  "property-description-translator": "/property-description-translator/static-1.4078",
  "HeadJS": "/HeadJS/static-2.789",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3378",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4558",
  "jasmine-runner": "/jasmine-runner/static-1.6689",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.867",
  "hubspotter-http": "/hubspotter-http/static-1.4819",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.564",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1032",
  "quartz-head": "/quartz-head/static-1.1022",
  "quartz-i18n": "/quartz-i18n/static-1.1032",
  "quartz-routing": "/quartz-routing/static-1.787",
  "quartz-test": "/quartz-test/static-1.1032",
  "quartz-tracking": "/quartz-tracking/static-1.736",
  "trellis-components": "/trellis-components/static-1.2465",
  "ui-fonts": "/ui-fonts/static-1.984",
  "usage-tracker-container": "/usage-tracker-container/static-1.7586",
  "usage-tracker-core": "/usage-tracker-core/static-1.7446",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7489",
  "reference-resolvers": "/reference-resolvers/static-1.8423",
  "sanitize-text": "/sanitize-text/static-1.8390",
  "PatternValidationJS": "/PatternValidationJS/static-1.3136",
  "ReduxMessenger": "/ReduxMessenger/static-2.10606",
  "sanitize": "/sanitize/static-1.4716",
  "outpost": "/outpost/static-1.4402",
  "rpc-client-utils": "/rpc-client-utils/static-1.4903",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4641",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9666",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2446",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3177",
  "foundations-theming-base": "/foundations-theming-base/static-1.3679",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.250",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.10",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9567",
  "atom": "/atom/static-1.5317",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8121",
  "ContentUtils": "/ContentUtils/static-1.69040",
  "data-token-picker": "/data-token-picker/static-1.16805",
  "file-manager-components": "/file-manager-components/static-1.24342",
  "FileManagerCore": "/FileManagerCore/static-1.39841",
  "FileManagerLib": "/FileManagerLib/static-1.39982",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8168",
  "hub-http-contrib": "/hub-http-contrib/static-1.3279",
  "interframe": "/interframe/static-3.4996",
  "layout-dnd-components": "/layout-dnd-components/static-1.12879",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11854",
  "property-translator": "/property-translator/static-1.5634",
  "react-codemirror": "/react-codemirror/static-1.10880",
  "react-colorpicker": "/react-colorpicker/static-2.10447",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8339",
  "rich-text-lib": "/rich-text-lib/static-1.20225",
  "tinymce-data": "/tinymce-data/static-1.41072",
  "tinymce-themes": "/tinymce-themes/static-1.56957",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10126",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5453",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16197",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10514",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10512",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5282",
  "base-ui": "/base-ui/static-1.18",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1200",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.313",
  "chirp-fetch": "/chirp-fetch/static-1.2129",
  "chatspot-core": "/chatspot-core/static-1.22606",
  "copilot-toolkit": "/copilot-toolkit/static-1.11729",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13271",
  "data-fetching-client": "/data-fetching-client/static-1.9897",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4997",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8945",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29199",
  "usage-tracker": "/usage-tracker/static-1.7596",
  "cms-field-types": "/cms-field-types/static-1.5055",
  "content-icons-ui": "/content-icons-ui/static-1.2304",
  "integrations-lib": "/integrations-lib/static-1.16910",
  "customer-data-objects": "/customer-data-objects/static-1.7927",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1555",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4897",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4392",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9317",
  "video-components-external": "/video-components-external/static-1.12038",
  "video-data-lib": "/video-data-lib/static-1.35696",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.159",
  "audio-components": "/audio-components/static-1.6263",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29724",
  "FileManagerImages": "/FileManagerImages/static-1.37493",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1397",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.73",
  "salesImages": "/salesImages/static-1.530",
  "ui-universal-auth": "/ui-universal-auth/static-1.9273",
  "urlinator": "/urlinator/static-1.4773",
  "video-components": "/video-components/static-1.14040",
  "video-embed": "/video-embed/static-1.36530",
  "ts-schema": "/ts-schema/static-1.4249",
  "ContentData": "/ContentData/static-1.69115",
  "layout-data-lib": "/layout-data-lib/static-1.10179",
  "react-dnd-compat": "/react-dnd-compat/static-1.4856",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1785",
  "external-options-client-types": "/external-options-client-types/static-1.4296",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7133",
  "hs-promise-utils": "/hs-promise-utils/static-1.5835",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4013",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9218",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3301",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11385",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5715",
  "magpie-types": "/magpie-types/static-1.5175",
  "simple-logging-lib": "/simple-logging-lib/static-1.3289",
  "avatar-components": "/avatar-components/static-1.2737",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10066",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6823",
  "flux-actions": "/flux-actions/static-1.360",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5118",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14325",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5848",
  "laboratory-lib": "/laboratory-lib/static-3.7392",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8017",
  "redux-observable": "/redux-observable/static-1.71",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10502",
  "unified-auth": "/unified-auth/static-1.787",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.533",
  "breeze-engine-core": "/breeze-engine-core/static-1.833",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.8029",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13083",
  "content-media-compositions": "/content-media-compositions/static-2.17090",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19326",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1069",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15502",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12385",
  "ExportDialog": "/ExportDialog/static-6.10620",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34693",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3969",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4305",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.252",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4176",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7038",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3863",
  "persist-promise": "/persist-promise/static-1.3942",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5855",
  "reactive-lib": "/reactive-lib/static-1.961",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.577",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3250",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.336",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.948",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.914",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1068",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.358",
  "slack-ui-library": "/slack-ui-library/static-1.10637",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3978",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15501",
  "simple-menus-lib": "/simple-menus-lib/static-1.17018",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3751",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9974",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
